import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import EmbeddedCrossSellOfferCon from '../../EmbeddedCrossSellOfferCon';

import { MButton } from '../../../../atoms/MButton';
import CheckboxProduct from './product';

import { StyledCheckboxEmbeddedWidgetCon, AddButtonCon } from './skins';

export default function CheckboxLayout(props) {
  const {
    isMobile,
    displayProducts,
    selectedVariantInfo,
    theme,
    withCarousel,
    carouselItemsToShow,
    isProductAddonActionLoading,
    embeddedWidgetStyles,
    onAddProductAddonsToCart,
    offerLevelQuantityAdded,
    offerLevelDiscountQuantity,
    isProductAddonAdded,
    isCarouselArrowsAlwaysVisible,
    ...restProps
  } = props;

  const {
    atcButtonStyle,
    atcButtonBackgroundColor,
    atcButtonBorderColor,
    atcButtonBorderRadius,
    atcButtonTextColor,
    atcButtonFontSize,
    atcButtonMobileFontSize,
    atcButtonFontStyle,
    atcButtonFontWeight,
    atcButtonTextDecoration,
    atcButtonTextAlignment,
    atcButtonFontFamily,
    atcButtonPadding,
    atcButtonMargin,
    atcButtonHeight,
    atcButtonWidth,
    atcProductAddingText,
    atcProductAddedText,
  } = props.productActionButtonStyles;

  let atcStatusText = theme.productAddonAddToCartText;
  if (isProductAddonActionLoading) atcStatusText = atcProductAddingText;
  else if (isProductAddonAdded) atcStatusText = atcProductAddedText;

  const isATCInIntermediateState =
    isProductAddonActionLoading || isProductAddonAdded;

  return (
    <StyledCheckboxEmbeddedWidgetCon
      {...embeddedWidgetStyles}
      className="mr-embedded-widget mr-embedded-widget--cross-sell mr-embedded-widget--checkbox"
    >
      <EmbeddedCrossSellOfferCon
        isMobile={isMobile}
        renderInCarousel={withCarousel}
        carouselItemsToShow={carouselItemsToShow}
        offerHeaderText={theme.offer_header_text}
        offerHeaderFontSize={
          isMobile ? theme.offerHeaderMobileFontSize : theme.offerHeaderFontSize
        }
        offerHeaderMobileFontSize={theme.offerHeaderMobileFontSize}
        offerHeaderFontStyle={theme.offerHeaderFontStyle}
        offerHeaderFontWeight={theme.offerHeaderFontWeight}
        offerHeaderTextColor={theme.offerHeaderTextColor}
        offerHeaderTextDecoration={theme.offerHeaderTextDecoration}
        offerHeaderFontFamily={theme.offerHeaderFontFamily}
        offerHeaderTextAlignment={theme.offerHeaderTextAlignment}
        offerHeaderPadding={
          isMobile ? theme.offerHeaderMobilePadding : theme.offerHeaderPadding
        }
        offerHeaderMargin={
          isMobile ? theme.offerHeaderMobileMargin : theme.offerHeaderMargin
        }
        offerHeaderMobilePadding={theme.offerHeaderMobilePadding}
        offerSubtitleText={theme.offerSubtitleText}
        offerSubtitleFontSize={
          isMobile
            ? theme.offerSubtitleMobileFontSize
            : theme.offerSubtitleFontSize
        }
        offerSubtitleMobileFontSize={theme.offerSubtitleMobileFontSize}
        offerSubtitleFontStyle={theme.offerSubtitleFontStyle}
        offerSubtitleFontWeight={theme.offerSubtitleFontWeight}
        offerSubtitleTextColor={theme.offerSubtitleTextColor}
        offerSubtitleTextDecoration={theme.offerSubtitleTextDecoration}
        offerSubtitleFontFamily={theme.offerSubtitleFontFamily}
        offerSubtitleTextAlignment={theme.offerSubtitleTextAlignment}
        offerSubtitlePadding={
          isMobile
            ? theme.offerSubtitleMobilePadding
            : theme.offerSubtitlePadding
        }
        offerSubtitleMargin={
          isMobile ? theme.offerSubtitleMobileMargin : theme.offerSubtitleMargin
        }
        productsContainerPadding={theme.productsContainerPadding}
        productsContainerMargin={theme.productsContainerMargin}
        offerLevelQuantityAdded={offerLevelQuantityAdded}
        offerLevelDiscountQuantity={offerLevelDiscountQuantity}
        countOfItemsInOffer={displayProducts.length}
        productButtonColor={theme.productButtonColor}
        productButtonStyle={theme.embeddedProductButtonStyle}
        productButtonTextColor={theme.embeddedProductButtonTextColor}
        isCarouselArrowsAlwaysVisible={isCarouselArrowsAlwaysVisible}
      >
        {displayProducts.map((product, i) => (
          <Fragment key={`index-${i * 1}`}>
            <CheckboxProduct
              isMobile={isMobile}
              product={product}
              selectedVariant={selectedVariantInfo[product.originalIndex]}
              theme={theme}
              {...restProps}
            />
          </Fragment>
        ))}
      </EmbeddedCrossSellOfferCon>

      {/* TODO: */}
      {/* // review: if a string is used more than 3 times add to to constants, guidline added */}
      {theme.widgetPosition === 'below_atc' && (
        <AddButtonCon>
          <MButton
            className="mr-product-addons-add-button"
            onClick={onAddProductAddonsToCart}
            buttonStyle={atcButtonStyle}
            backgroundColor={atcButtonBackgroundColor}
            borderColor={atcButtonBorderColor}
            borderRadius={atcButtonBorderRadius}
            textColor={atcButtonTextColor}
            fontSize={atcButtonFontSize}
            mobileFontSize={atcButtonMobileFontSize}
            fontStyle={atcButtonFontStyle}
            fontWeight={atcButtonFontWeight}
            textDecoration={atcButtonTextDecoration}
            textAlignment={atcButtonTextAlignment}
            fontFamily={atcButtonFontFamily}
            padding={atcButtonPadding}
            margin={atcButtonMargin}
            height={atcButtonHeight}
            width={
              atcButtonWidth && atcButtonWidth !== '0' ? atcButtonWidth : '100%'
            }
            disabled={isATCInIntermediateState}
            opacity={isATCInIntermediateState ? '0.7' : '1'}
          >
            {atcStatusText}
          </MButton>
        </AddButtonCon>
      )}
    </StyledCheckboxEmbeddedWidgetCon>
  );
}

CheckboxLayout.propTypes = {
  isMobile: PropTypes.bool,
  displayProducts: PropTypes.array,
  selectedVariantInfo: PropTypes.array,
  theme: PropTypes.object,
  productActionButtonStyles: PropTypes.object,
  isProductAddonActionLoading: PropTypes.bool,
  onAddProductAddonsToCart: PropTypes.func,
  embeddedWidgetStyles: PropTypes.object,
  offerLevelQuantityAdded: PropTypes.number,
  offerLevelDiscountQuantity: PropTypes.number,
  isProductAddonAdded: PropTypes.bool,
  isCarouselArrowsAlwaysVisible: PropTypes.bool,
  withCarousel: PropTypes.bool,
  carouselItemsToShow: PropTypes.number,
};
